import { render, staticRenderFns } from "./modalsPreviewDetailRating.vue?vue&type=template&id=be7baa22&scoped=true"
import script from "./modalsPreviewDetailRating.vue?vue&type=script&lang=js"
export * from "./modalsPreviewDetailRating.vue?vue&type=script&lang=js"
import style0 from "./modalsPreviewDetailRating.vue?vue&type=style&index=0&id=be7baa22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be7baa22",
  null
  
)

export default component.exports